import { climateAttrs } from '../store/constants/climateAttrs';
import formatNumber from './formatNumber';

// Used to retrieve necessary text from the attributeOptions object, defined above
export function getAttributeText(isClimate, option) {
  let attrName, unit, popupUnit;

  if (isClimate) {
    let attr = climateAttrs.find((attr) => attr.id === option);
    try {
      attrName = attr['title'];
      if (attr['dayUnits']) {
        unit = 'Number of Days';
        popupUnit = 'days';
      } else if (attr['precip']) {
        unit = 'Precipitation (in)';
        popupUnit = 'in';
      } else {
        unit = 'Temperature (°F)';
        popupUnit = '°F';
      }
    } catch {
      // Ignore error due to rendering attempts before data is loaded
    }
  } else {
    switch (option) {
      case 'count':
        attrName = 'Total Reported Episodes';
        unit = 'episodes';
        break;
      case 'damageCrops':
        attrName = 'Total Reported Crop Damage';
        unit = '';
        break;
      case 'damageProperty':
        attrName = 'Total Reported Property Damage';
        unit = '';
        break;
      case 'deaths':
        attrName = 'Total Reported Deaths';
        unit = 'deaths';
        break;
      case 'injuries':
        attrName = 'Total Reported Injuries';
        unit = 'injuries';
        break;
      default:
        break;
    }
  }

  return { attrName, unit, popupUnit };
}

export const getClimateNumber = (isState, data, featureId) => {
  try {
    const number = data[isState ? 'state' : 'county'][featureId];
    if (number === undefined) {
      throw new Error('Climate type is undefined');
    }
    return number.toFixed(2);
  } catch {
    return 0;
  }
};

export const getHazardNumber = (isState, data, metric, featureId) => {
  try {
    const number = data[isState ? 'state' : 'county'][metric][featureId];

    if (number === undefined) {
      throw new Error('Hazard type is undefined');
    }

    return formatNumber(number);
  } catch {
    return 0;
  }
};
